export enum LogicFlowExecutionStatusEnum {

    CREATED,
    RUNNING,
    PAUSED,
    COMPLETED,
    FAILED,
}
